import React from 'react';
import { BestForBrowseVenueData } from 'js/model/rainbow/best-for-browse-page/BestForBrowsePageVenueData';
import { choiceFormatter } from 'js/helpers/choice-formatter';
import { Rating } from '@treatwell/ui';
import {
  trackGoToVenueClick,
  ClickTarget,
} from 'js/pages/BestForBrowsePage/tracking';
import styles from './RatingWithReviews.module.css';

interface Props {
  displayAverage?: string;
  reviewCountText: string;
  reviewCountHref: string;
  reviewCountOnClick?: (event: React.SyntheticEvent<HTMLAnchorElement>) => void;
}

export function RatingWithReviews(props: Props): React.ReactElement {
  return (
    <div className={styles.container}>
      {props.displayAverage !== undefined && (
        <div className={styles.rating}>
          <Rating rating={props.displayAverage} size={16} showRatingValue />
        </div>
      )}

      <a
        href={props.reviewCountHref}
        onClick={props.reviewCountOnClick}
        className={styles.reviews}
      >
        {props.reviewCountText}
      </a>
    </div>
  );
}

type GenerateUriFunction = (
  pageType: 'venue',
  values: { normalisedName: [string] }
) => string;

export function createRatingWithReviewsViewModel(
  data: BestForBrowseVenueData,
  cms: { 'num-reviews-template': string },
  generateUriFunction: GenerateUriFunction
): Props {
  return {
    displayAverage: data.rating.displayAverage,
    reviewCountText: choiceFormatter(
      cms['num-reviews-template'],
      data.rating.count
    ),
    reviewCountHref: `${generateUriFunction('venue', {
      normalisedName: [data.normalisedName],
    })}#reviews`,
    reviewCountOnClick: (event) =>
      trackGoToVenueClick(event, ClickTarget.ReviewsCount, data.venueId),
  };
}
